const INSPECTION_SUBMIT_DUE_DT = {
  DIFF_FROM_PRODUCT_DEPLOY_AT: {
    MIN: 9,
    AUTO: 9,
  },
}

const INSPECTION_FEEDBACK_DUE_DT = {
  DIFF_FROM_INSPECTION_SUBMIT_DUE_DT: {
    MIN: 1,
    AUTO: 1,
  },
}

const POLICIES = {
  INSPECTION_SUBMIT_DUE_DT,
  INSPECTION_FEEDBACK_DUE_DT,
}

export default POLICIES